import React, { useCallback } from 'react';
import { useFormikContext } from 'formik';

import { PersonalStepValues } from '../../state/types';
import { SignupField } from './PersonalStep.styles';
import { trackSignupStep } from '../../trackSignupUtils';
import { noSpaces } from '../../validations';

const CouponInput = () => {
  const { errors, touched, handleBlur, values, setFieldValue } =
    useFormikContext<PersonalStepValues>();

  const helperText: React.ReactNode = touched.coupon && errors.coupon;
  const hasCouponError = !!(errors.coupon && touched.coupon);

  const onBlurHandler = useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      trackSignupStep({
        name: 'user_full_coupon',
        stepValue: values.coupon,
      });
      handleBlur(event);
    },
    [handleBlur, values.coupon],
  );

  const onChangeHandler = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setFieldValue('coupon', noSpaces(event.target.value));
    },
    [setFieldValue],
  );

  return (
    <SignupField
      label="Cupom"
      id="coupon"
      name="coupon"
      type="text"
      placeholder="Campo opcional"
      autoComplete="coupon"
      margin="normal"
      error={hasCouponError}
      helperText={helperText}
      fullWidth
      onBlur={onBlurHandler}
      onChange={onChangeHandler}
      value={values.coupon}
    />
  );
};

export default CouponInput;
